// src/App.js
import React, { useContext } from 'react';
import ItemList from './itemList';
import Header from './header';
import Footer from './footer';
import { useParams } from 'react-router-dom'; 
import { scooties, bikes, cars } from '../../global-const';
import SpaceDiv from './spaceDiv';
import CarContext from './carProvider';

const Vehicle = () => {
  const {name :vehicle } = useParams(); 
  let vehicleName;
  // const { lars, loading } = useContext(CarContext);
  let itemsToRender;
 console.log(vehicle);
  // Conditional rendering logic
  if (vehicle === 'cars') {
    itemsToRender = cars;
    vehicleName = 'Cars'
  } else if (vehicle === 'scooties') {
    itemsToRender = scooties;
    vehicleName = 'Scooties'
  } else if (vehicle === 'bikes') {
    itemsToRender = bikes;
    vehicleName = 'Bikes'
  } else {
    itemsToRender = []; // Fallback in case vehicle is not valid
  }

  //  if (loading) {
  //   return (
  //     <div>
  //       <Header />
  //       <SpaceDiv/>
  //       <SpaceDiv/>
  //       <Footer />
  //     </div>
  //   );
  // }

  return (
    <div>
      <Header />
      <SpaceDiv/>
      <ItemList itemName={vehicleName} items={itemsToRender} />
      <SpaceDiv/>
      <Footer />
    </div>
  );
};

export default Vehicle;
